<template>
  <PageLoader v-if="isLoading" />
  <div class="w-100 py-5 px-10">
    <div style="height: 100%!important; width: 100%" class="scroll-container">
      <div id="kt_docs_jkanban_rich"></div>
    </div>
  </div>
  <NewTaskModal id="create_new_kanban_task" :form="formData" @reloadData="reload"/> 
  <ValidateChecklistModal id="check_todo_list" :data="checklistData" @reloadData="reload"/>
  <AddTaskUsersOrEndDateModal id="add_task_users_or_end_date" :users="users" :formEdit="formEditData" @load="afterPerformAction" @cancel="cancelDragTask"/>

  <UpdateTaskModal id="update_modal_task" :formEdit="formEditTaskData" @load="loadTaskByStatus(true)"/>
  <AddSubTaskModal id="add_sub_task_modal" :task-id="formEditTaskData.task_id" @callback="loadTaskByStatus(true)"/>
  <AttachFileToTaskModal id="attach_file_to_task_modal" :task-id="formEditTaskData.task_id" @callback="loadTaskByStatus(true)"/>
  <SendTaskCommentModal id="send_task_comment_modal" :task-id="formEditTaskData.task_id" @callback="loadTaskByStatus(true)"/>
</template>

<script setup>
import {onMounted, ref, shallowRef, defineProps, watch, defineExpose, computed, nextTick, onBeforeMount} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {Theme} from "@/composables/theming";
import PageLoader from "@/components/PageLoader.vue";
import NewTaskModal from "../../components/Modals/Task/NewTaskModal.vue";
import {formatRemainingTime, subText} from "@/mixins/Helpers";
import ValidateChecklistModal from "./components/ValidateChecklistModal.vue";
import { useLocales } from "@/composables/locales";
import {useSwal} from "@/composables/useSwal";
import AddTaskUsersOrEndDateModal from "@/Modules/Projects/components/Modals/Task/AddTaskUsersOrEndDateModal.vue";
import {format} from "date-fns";
import abilities from "@/composables/abilities";
import { useHasAbility } from "@/composables/hasAbility";
import {useProjectEnums} from "@/Modules/Projects/composables/projectEnums";
import UpdateTaskModal from "@/Modules/Projects/components/Modals/Task/UpdateTaskModal.vue";
import AddSubTaskModal from "@/Modules/Projects/components/Modals/Task/AddSubTaskModal.vue";
import AttachFileToTaskModal from "@/Modules/Projects/components/Modals/Task/AttachFileToTaskModal.vue";
import SendTaskCommentModal from "@/Modules/Projects/components/Modals/Task/SendTaskCommentModal.vue";

const store = useStore()
const router = useRouter()
const route = useRoute()
const {showSwal} = useSwal()
const {can} = useHasAbility()

const { taskQuickActions } = useProjectEnums()
const {locale} = useLocales()

const emits = defineEmits(['change'])

const props = defineProps({ 
  filter: {
    type: Object,
    default: () => ({
      startDate: '',
      endDate: '',
      status: '',
      contact: '',
      search: '',
      seller: '',
      priority: '',
      milestone: ''
    })
  }
})

const isLoading = ref(true)
const kanban = shallowRef(null)
const taskStatus = shallowRef([])
const multipleSelectForm = ref({
  all: true,
  task_ids: [],
  task_status_id: ''
})

const formData = ref({
  title: "",
  project_id: "",
  project_category_step_id: "",
  task_status_id: "",
  task_priority_id: "",
  description: "",
  users: [],
  start_date: '',
  end_date: '',
  need_review: false
})
const formEditData = ref({
  title: "",
  project_id: "",
  project_category_step_id: "",
  task_status_id: "",
  task_priority_id: "",
  description: "",
  users: [],
  source: '',
  end_date: format(new Date(), 'dd-MM-yyyy HH:mm'),
  need_review: false
})
const formEditTaskData = ref({
  task_id: ''
})
const checklistData = ref({})
const currentProject = computed(() => store.getters['projects/getCurrentProject'])
const users = computed(() => {
  if(currentProject.value && currentProject.value.users && currentProject.value.users.length ){
    let users = [...currentProject.value.users]
    currentProject.value.managers.forEach((manager) => {
      if(!users.find(user => user.id === manager.id)) {
        users.push(manager)
      }
    })
    return users
  }
  return []
})

const controlledStatus = computed(() => {
  if(taskStatus.value?.length > 0){
    return taskStatus.value?.filter(stat => stat.is_review  || stat.is_complete)?.map(el => el?.id)
  }

  return []
})

const completedStatusId = computed(() => {
  let status = (taskStatus.value ?? []).filter(el => el.is_complete).map(el => el.id)
  if(status?.length > 0){
    return status[0]
  }

  return ''
})

const reviewedStatusId = computed(() => {
  let status = (taskStatus.value ?? []).filter(el => el.is_review).map(el => el.id)
  if(status?.length > 0){
    return status[0]
  }

  return ''
})



watch(() => props.filter, (value) => {
  if (!isLoading.value) {
    loadTaskByStatus(true)
  }
}, {deep: true})

window.toggleForm = function toggleForm(taskStatutId) {
  formData.value = {...formData.value, task_status_id: taskStatutId,project_category_step_id: props.filter.milestone}
  $("#create_new_kanban_task").modal('toggle')
}

window.move = function move() {
  if(multipleSelectForm.value.task_ids?.length > 0 ){
      store.dispatch('tasks/changeMultipleTaskStatut', multipleSelectForm.value)
        .then(res => {
          loadTaskByStatus(true)
          emits('change')
        })
        .catch((err) => {})
  }else{
    window.toastr.error(i18n.global.t("notification.no_task_selected"))
  }
}

window.goToTaskView = function goToTaskView(id) {
  router.push({ name: 'tasks-view', params: { id: id, project: route.params.id } })
}

window.goToChecklist = function goToChecklist(data){
  let formData = JSON.parse(data)
  checklistData.value = formData
  $("#check_todo_list").modal('toggle')

}

window.handleCheckboxChange = function handleCheckboxChange(checkbox, id = null){
  let isChecked = checkbox.target.checked
 

  if (id) {
    if (isChecked) {
      multipleSelectForm.value.task_ids = [...new Set([...multipleSelectForm.value.task_ids, id])]
    } else {
      multipleSelectForm.value.task_ids = multipleSelectForm.value.task_ids.filter(el => el !== id)
    }
  } else {
    if(isChecked && completedStatusId){
      const status = (taskStatus.value ?? []).filter(el => el.is_complete)[0]
      const allIds = (status?.tasks || []).map(el => el?.id).filter(Boolean);
      multipleSelectForm.value.task_ids = allIds
    }else{
      multipleSelectForm.value.task_ids = []
    }
  }

   nextTick(() => {
    checkbox.target.setAttribute('checked', 'checked')
    updateBoardElement()
    updateBoards()
  })
}

function jkanbanInit() {
  "use strict";

   destroyKanban()

  if (!kanban.value) {
    let KTJKanbanDemoRich = function () {
      let boards = [];
      taskStatus.value.forEach((taskStatut, index) => {
        let items = [];
        items = taskStatut?.tasks?.map((taskItem, index) => {
          return taskStepItem(taskStatut.id, index + 1, taskItem, taskStatut?.is_review);
        });

        boards.push(
            taskStep(taskStatut.id, taskStatut.title, taskStatut.color, items, index) 
        );
      });

      let exampleRich = function () {


        kanban.value = new jKanban({
          element: '#kt_docs_jkanban_rich',
          gutter: '0',
          widthBoard: '325px',
          dragendEl: changeTaskStatus,
          dropEl: changeTaskPosition,
          dragendBoard: changeStatutPosition,
          dragItems: true,
          boards: boards
        });

      }   



      return {
        init: function () {
          exampleRich();
          const forms = document.querySelectorAll('.taskStepItemForm')
          let clickedButton = null
          forms.forEach(form => {
            const buttons = form.querySelectorAll('button[type="submit"]');

            buttons.forEach(button => {
              button.addEventListener('click', (e) => {
                clickedButton = e.target;
              });
            });

            form.addEventListener('submit', (e) => {
              e.preventDefault();
              if (clickedButton) {
                submitForm(clickedButton.getAttribute('data-board-id'), clickedButton.getAttribute('data-edit') || null);
              }
            });

          })
        }
      };
    }();

    KTUtil.onDOMContentLoaded(function () {
      KTJKanbanDemoRich.init();
    });
  }
}

function changeStatutPosition(el){
  const boardId = el.dataset.id
  const newOrder = el.dataset.order

  let form = {
    task_status_id: boardId,
    new_position: newOrder
  }

  store.dispatch('tasks/changeStatutPosition', form)
    .then((response) => {
      loadTaskByStatus(true)
    })
    .catch((err) => {
      window.toastr['error'](err.response.data.message || err.message)
    })
}

const destroyKanban = () => {
  const kanbanElement = document.getElementById('kt_docs_jkanban_rich');
  if (kanbanElement) {
    kanbanElement.innerHTML = '';
  }
};

function taskStep(boardId, boardName, bordColor, items = [], index) {
  let checkboxHtml = "", cl = "d-none", btn = ""

  if(controlledStatus.value.length > 1){
    let shouldBeChecked = multipleSelectForm.value.task_ids?.length === taskStatus.value[multipleSelectForm.value.task_status_id]?.tasks?.length
    checkboxHtml = boardId === completedStatusId.value ? `
      <div class="form-check form-check-sm form-check-custom  me-2">
        <input id="${'boardCheckbox'+boardId}" class="form-check-input widget-9-check" type="checkbox" onchange="event.stopPropagation(); handleCheckboxChange(event)"  ${shouldBeChecked ? 'checked' : ''} >
      </div>
    ` : ''

      if( boardId === completedStatusId.value ){
        btn = ` <button id="${'board'+boardId}" class="btn btn-sm btn-primary d-none" type="button" onclick=move()>
            Déplacer
          </button>
        `
      }

       
  }



  return ({
    id: boardId,
    title: `
      <div>
        <div class="d-flex align-items-center mb-3 justify-content-between">
          <h3 class="card-title d-flex w-75">
            ${checkboxHtml}
            <span>${boardName}</span> 
            <span id="board-${boardId}-count" class="badge badge-light rounded-4 w-30px ms-3 d-flex justify-content-center"> ${items.length} </span>

          </h3>
          <div>
            ${btn}
            <i onclick="toggleForm('${boardId}')" class="icon_hover fa fa-plus fs-4"></i>
          </div>
        </div>
        <div class="row g-2">
        ${getStepBar(bordColor)}
        </div>
        <div class="mt-4">
          
        </div>
      </div>
    `,
    class: 'align-items-stretch',
    item: items
  })
}

function assignedItem(user = {}) {
  const initital = user?.initials;
  const fullName = `${user?.lastname} ${user?.firstname}`;

  return `
    <div key="${user?.id}" class="symbol symbol-20px symbol-circle" title="${fullName}">
      <span class="symbol-label bg-primary text-inverse-primary fw-bolder">${initital}</span>
    </div>
  `;
}

function taskStepItem(boardId, position, task = {}, review) {
  let initialName = '', checkboxHtml=""
  if (task.creator_id) {
    initialName = task?.creator?.firstname + ' ' + task?.creator?.lastname
  }
  const checkedCount = task?.checklists?.filter(item => item.checked)?.length || 0;


  const data = JSON.stringify({
    id: task?.id,
    checklists: task?.checklists
  }).replace(/"/g, '&quot;')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '&quot;')
      .replace(/'/g, "\\'")
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r');

  const checklistHTML = task?.checklists?.length > 0
      ? `
      <div class="" id="subtask_accordion_${task.id}">
        <div class="accordion-item border-0">
          <div class="accordion-header" id="subtask_accordion_${task.id}_header">
            <div class="d-flex align-items-center justify-content-between"
              style="cursor: pointer !important;"
               data-bs-toggle="collapse"
                 data-bs-target="#subtask_accordion_${task.id}_body" aria-expanded="true" aria-controls="subtask_accordion_${task.id}_body"
              >
              <span class="small text-primary fw-bold">
                <i class="bi bi-check-square-fill me-2 text-primary fw-bold"></i>
                ${i18n.global.t('tasks.todo')}
              </span>
              <span id="task_subtask_check_count_${task.id}"> ${checkedCount}/${task?.checklists?.length} </span>
            </div>
           </div>
           <div id="subtask_accordion_${task.id}_body" class="accordion-collapse collapse" aria-labelledby="subtask_accordion_${task.id}_header" data-bs-parent="#subtask_accordion_${task.id}">
              <div class="accordion-body p-0">
                 <hr class="hr my-3"/>
                 ${generateSubTaskCheckBox(task?.checklists, task.id)}
              </div>
            </div>
          </div>
        </div>
    `
      : '';

  let assigned = '';
  assigned = task?.users?.length > 0
      ? task?.users?.map((user) => {
        return assignedItem(user);
      }).join('')
      : '';

  const lastActionHTML = task?.history ? `
          <div class="d-flex align-items-center justify-content-between ">
            <div><p>${i18n.global.t('projects.label.lastAction')}</p></div>
            <div title="${task?.history?.action[locale.value]}">
              <p>${subText(task?.history?.action[locale.value], 25)}</p>
            </div>
          </div>
          <div class="text-end justify-content-between ">
            <div ><p>${formatRemainingTime(task?.history?.date, locale.value)}</p></div>
          </div>
   ` : '';

  const taskAlertHtml = (task?.is_late || task?.on_alert) && !review ? `<div class="alert-badge w-20px h-20px p-2 d-flex align-items-center justify-content-center" style="background-color: transparent !important; box-shadow: 0 0 8px var(--bs-${task?.alert?.color}) !important;">
    <i class="${task?.alert?.icon} text-${task?.alert?.color} fs-2x"></i>  
  </div>` : ''
  const taskAlertCountHtml = task?.sample_alerts_count && !review ? `<span title="${task?.sample_alerts_count + ' ' + i18n.global.t("tasks.alert_delay")}" class="text-warning me-2"> ${parseInt(task?.sample_alerts_count)} <i class="ms-1 fa fa-clock text-warning"></i> </span>` : ''
  const taskAlertCriticCountHtml = task?.critical_alerts_count && !review ? `<span data-bs-toggle="tooltip data-bs-dismiss="hover"" data-bs-placement="top" title="${task?.critical_alerts_count + ' ' + i18n.global.t("tasks.critical_delay")}" class="text-danger">  ${parseInt(task?.critical_alerts_count)} <i class="ms-1 fa fa-clock text-danger"></i></span>` : ''

  if(controlledStatus.value.length > 1){
    const shouldBeChecked = multipleSelectForm.value.task_ids?.includes(task?.id)
    checkboxHtml = boardId === completedStatusId.value ? `
      <div class="form-check form-check-sm form-check-custom  me-2">
        <input id="task_checkbox_${task.id}" name="task_checkbox_${task.id}" class="widget-9-check form-check-input widget-9-check" type="checkbox" data="${shouldBeChecked}" onclick="handleCheckboxChange(event, '${task.id}')"  ${shouldBeChecked ? 'checked' : ''} >
      </div>
    ` : ''
  }

  const boardIndex = taskStatus.value.findIndex(el => el.id === boardId) || 0
  const prev = taskStatus.value[boardIndex - 1]?.id || 0
  const next = taskStatus.value[boardIndex + 1]?.id || 0


  const quickActionsHtml = `
    <div class="dropdown dropend ms-auto">
      <i class="fas fa-ellipsis-v fs-2 text-dark cursor-pointer" data-bs-toggle="dropdown" @click.stop.prevent></i>
      <ul class="dropdown-menu">
        ${generateTaskQuickAction(boardId, task.id)}
      </ul>
    </div>
    `


  return ({
    id: task.id,
    completed: task.completed_date,
    parent: boardId,
    position: position,
    prevBoard: prev,
    nextBoard: next,
    canMove: task.endDate || (task.users && task.users.length),
    title: `
      <div data-id="${task.id}" data-completed="${task.completed_date}" data-review="${task.need_review}" class="card mb-2 bord-item position-relative">
        <div class="p-4">
          ${taskAlertHtml}
          <div class="d-flex">
            ${checkboxHtml}
            <div onclick="event.stopPropagation(); goToTaskView('${task.id}')">
              <h3 onclick="event.stopPropagation(); goToTaskView('${task.id}')" class=" d-flex align-items-start ">
                <span title="${task.title}" class="card-label fw-bolder text-dark align-self-center">${subText(task.title)}</span>
                ${task?.need_review
                    ? task?.reviewed
                      ? '<img class="align-self-center mx-1 h-20px" src="/assets/media/tasks/validate.png" />' : '<img class="align-self-center mx-1 h-20px" src="/assets/media/tasks/review.png" />'
                    : ''
                }
                <span class="badge badge-light-primary align-self-center">${task?.taskPriority?.title}</span>
              </h3>
              <div class="d-flex">
                ${taskAlertCountHtml} 
                ${taskAlertCriticCountHtml}  
              </div>
            </div>
            ${quickActionsHtml}
          </div>
          <hr>
          
          <div class="d-flex align-items-center justify-content-between ">
            <div>
              <p>${i18n.global.t("tasks.createdBy")}</p>
            </div>
            <div class="">
              ${initialName}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between ">
            <div>
              <p>${i18n.global.t("tasks.delay")}</p>
            </div>
            <div title="${task?.project?.title}" class="">
              ${task?.endDate ? new Date(task?.endDate)?.toLocaleDateString() : ''}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between ">
            <div>
              <p>${i18n.global.t("tasks.created_at")}</p>
            </div>
            <div  class="">
              ${task?.startDate ? new Date(task?.startDate)?.toLocaleDateString() : ''}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between ">
            <div class="mt-2">
              <p>${i18n.global.t("tasks.users")}</p>
            </div>
            <div class="symbol-group symbol-hover">
              ${assigned}
            </div>
          </div>
         ${lastActionHTML}
         ${checklistHTML}
        </div>
      </div>
            `,
  })
}

function getStepBar(activeColor = Theme.blue) {
  let stepBar = ``
  for (let i = 0; i < 1; i++) {
    stepBar += `
      <div class="col">
        <div class="progress" style="height: 3px!important;" role="progressbar" aria-label="Example high" aria-valuemin="0" aria-valuemax="100">
          <div
              class="progress-bar ${'w-100'}"
              style="background-color: ${ activeColor + '!important'}; height: '3px' ">
          </div>
        </div>
      </div>
     `
  }
  return stepBar
}

function updateBoards() {
  const hasControlledStatus = controlledStatus.value?.length > 0;
  const selectedTaskIds = multipleSelectForm.value.task_ids || [];

  taskStatus.value.forEach((taskStatut, index) => {
    const boardId = `#board-${taskStatut.id}-count`;
    const checkboxId = `#boardCheckbox${taskStatut.id}`;
    const boardContainerId = `#board${taskStatut.id}`;
    
    // Met à jour le nombre de tâches
    $(boardId).text(taskStatut.tasks.length);

    if (hasControlledStatus && taskStatut.is_complete) {
      if (selectedTaskIds.length > 0) {
        $(boardContainerId).removeClass('d-none');

        const expectedCount = taskStatut?.tasks?.length ;
        const isAllSelected = selectedTaskIds.length === expectedCount;
        $(checkboxId).prop('checked', isAllSelected);
      } else {
        $(boardContainerId).addClass('d-none');
      }
    }
  });
}


function updateBoardElement() {
  if (kanban.value) {
    taskStatus.value.forEach((taskStatut) => {
      if(taskStatut){
        const boardElements = kanban.value.getBoardElements(taskStatut?.id)
        while (boardElements.length) {
          kanban.value.removeElement(boardElements[0]?.dataset.eid)
        }
        taskStatut?.tasks?.forEach((taskItem, index) => {
          const boardItemData = taskStepItem(taskStatut.id, index +1,  taskItem);
          kanban.value.addElement(taskStatut.id, boardItemData, 0);
        });
      }
    })
  }
}

async function loadTaskByStatus(isUpdate = false) {
  try {
    if(!isUpdate) {
      isLoading.value = true
    }
    let {data: tasksByStatus} = await store.dispatch('tasks/getProjectTasks', {id:route.params.id, filter: props.filter})
    taskStatus.value = tasksByStatus.data
    multipleSelectForm.value.task_status_id = [...tasksByStatus.data].pop()?.id

    if (isUpdate) {
      updateBoardElement()
      updateBoards()
    }
  }catch (e) {

  }finally {
    isLoading.value = false
  }
}

function sanitizedNul (data) {
  if(['', undefined, null, 'null'].includes(data)) return null
  return data
}

function changeTaskStatus(el) { 
  const target = el.offsetParent.dataset.id
  const source = el.dataset.parent
  const taskId = el.children[0].dataset.id
  const taskCompletedAt = sanitizedNul(el.children[0].dataset.completed)
  const taskNeedReview = el.children[0].dataset.review === 'true'

  if (source === target) return

  const data = { task_id: taskId, task_status_id: target }

  const openEndDateModal = () => {
    formEditData.value = {
      task_id: taskId,
      task_status_id: target,
      end_date: taskCompletedAt ?? format(new Date(), 'dd-MM-yyyy HH:mm'),
      source: source,
    }
    $('#add_task_users_or_end_date').modal('toggle')
  }

  const dispatchChangeTask = () => {
    store.dispatch('tasks/changeTaskStatut', data)
      .then(() => {
        loadTaskByStatus(true)
        emits('change')
      })
      .catch(() => {
        emits('change')
      })
  }

  if (target === completedStatusId.value) {
    taskCompletedAt != null ? dispatchChangeTask() : openEndDateModal()
  } else if (target === reviewedStatusId.value) {
    if (taskNeedReview && !can(abilities.TASK_PROJECT_CLOSE)) {
      cancelDragTask({ source, id: taskId })
      window.toastr['error'](i18n.global.t("permission_denied_text"))
    } else {
      taskCompletedAt != null ? dispatchChangeTask() : openEndDateModal()
    }
  } else {
    dispatchChangeTask()
  }
}


function cancelDragTask({source, id}) {

  if (kanban.value) {
    let status = taskStatus.value.find(el => el?.id == source)
    status?.tasks?.forEach((taskItem, index) => {
        kanban.value.removeElement(taskItem?.id)
        const boardItemData = taskStepItem(status.id, index +1,  taskItem);
        kanban.value.addElement(status.id, boardItemData, 0);
    });
  }
}


function afterPerformAction(actionData) {
  loadTaskByStatus(true)
  emits('change')
}

function changeTaskPosition(el, target, source, sibling) {

  if(target.offsetParent.dataset.id !== source.offsetParent.dataset.id) {
    return ;
  }
  const taskId = el.dataset.eid
  let targetPosition = 0;
  if(!sibling) {
    targetPosition = target.childElementCount
  } else {
    const siblingPosition = parseInt(sibling.dataset.position)
    const currentPosition = parseInt(el.dataset.position)
    targetPosition = currentPosition < siblingPosition ? siblingPosition -1 : siblingPosition
  }
  store.dispatch('tasks/changeTaskPosition', {
    task_id: taskId,
    new_position: targetPosition
  })
      .then(res => {
        loadTaskByStatus(true)
        emits('change')
      })
      .catch((err) => {
        window.toastr['error'](err.response.data.message || err.message)
      })
}

function generateSubTaskCheckBox(options = [], id) {
  let checkboxes = '';
  options.forEach((option) => {
    if(option.checked) {
      checkboxes += `
      <div class="mb-2 d-flex align-items-center gap-2">
        <i id="${option.id.toString().trim()}" onclick="event.stopPropagation(); setSubtaskStatus('${option.id}', '${id}')" class="cursor-pointer fs-2 bi bi-check-square-fill text-primary checked"></i>
        <label onclick="event.stopPropagation(); setSubtaskStatus('${option.id}', '${id}')" for="${option.id}" title="${option.title}" class="form-check-label fs-6 fw-bolder text-black cursor-pointer d-inline-block text-truncate" style="max-width: calc(100% - 30px);">
          ${option.title} 
        </label>
      </div>
    `;
    } else {
      checkboxes += `
      <div class="mb-2 d-flex align-items-center gap-2">
        <i id="${option.id.toString().trim()}" onclick="event.stopPropagation(); setSubtaskStatus('${option.id}', '${id}')" class="cursor-pointer fs-2 bi bi-square"></i>
        <label onclick="event.stopPropagation(); setSubtaskStatus('${option.id}', '${id}')" for="${option.id}" title="${option.title}" class="form-check-label fs-6 fw-bolder text-black cursor-pointer d-inline-block text-truncate" style="max-width: calc(100% - 30px);">
          ${option.title}
        </label>
      </div>
    `;
    }

  });

  return checkboxes;
}

function generateTaskQuickAction(stepId, taskId) {
  let actions = ''
  Object.keys(taskQuickActions.value).forEach((action) => {
    actions += `
        <li>
          <span
              class="dropdown-item d-flex align-items-center"
              style="cursor: pointer;"
              onclick="event.stopPropagation(); handleTaskAction('${stepId}', '${taskId}', '${action}')"
          >
              <span><i class="${taskQuickActions.value[action]?.icon} me-3"></i>${i18n.global.t(taskQuickActions.value[action]?.name)}</span>
          </span>
        </li>
    `
  })

  return actions
}

window.handleTaskAction = function (stepId, taskId, action) {

  switch (action) {
    case taskQuickActions.value.EDIT.value:
      const step = taskStatus.value.find(step => step.id === stepId)
      const task = step.tasks.find(task => task.id === taskId)

      if(task.id) {
        formEditTaskData.value = {
          id: task?.id,
          title: task?.title,
          project_id: task?.project_id,
          project_category_step_id: task?.project_category_step_id,
          task_status_id: stepId,
          task_priority_id: task?.task_priority_id,
          description: task?.description,
          users: task?.users?.map(el => el?.id),
          delay_value: task?.delay_value,
          delay_unit: task?.delay_unit,
          delay_value_alert: task?.delay_value_alert,
          delay_unit_alert: task?.delay_unit_alert,
          delay_value_critical: task?.delay_value_critical,
          delay_unit_critical: task?.delay_unit_critical,
          start_date: task?.startDate && format(task?.startDate, 'dd-MM-yyyy HH:mm'),
          end_date: task?.endDate && format(task?.endDate, 'dd-MM-yyyy HH:mm'),
          task_id: task?.id,
          need_review: task?.need_review
        }
        $('#update_modal_task').modal('toggle')
      }

      break;
    case taskQuickActions.value.DELETE.value:
      showSwal(
          i18n.global.t('swal.task_delete'),
          i18n.global.t('swal.task_delete_text')
      ).then(async (result) => {
        if (result.value) {

          store.dispatch('tasks/deleteTask', taskId)
              .then((res) => loadTaskByStatus(true))
              .catch()

        }
      })
      break;
    case taskQuickActions.value.ADD_SUB_TASK.value:
      formEditTaskData.value = {
        task_id: taskId,
      }
      $('#add_sub_task_modal').modal('toggle')
      break;
    case taskQuickActions.value.ADD_COMMENT.value:
      formEditTaskData.value = {
        task_id: taskId,
      }
      $('#send_task_comment_modal').modal('toggle')
      break;
    case taskQuickActions.value.ADD_FILE.value:
      formEditTaskData.value = {
        task_id: taskId,
      }
      $('#attach_file_to_task_modal').modal('toggle')
      break;
  }
}

window.setSubtaskStatus = function setSubtaskStatus(id, taskId) {
  const checkbox = document.getElementById(id.toString().trim());

  if (!checkbox) return;

  store.dispatch('checklists/changeChecklistStatus', {
    id: id
  })
      .then((res) => {
        const checkedClasses = ['bi-check-square-fill', 'text-primary', 'checked'];
        const notCheckedClasses = ['bi-square'];
        const isChecked = checkbox.classList.contains('checked');
        const counter = document.getElementById('task_subtask_check_count_' + taskId)
        const [count, total] = counter.textContent.toString().split('/')
        if (isChecked) {
          checkbox.classList.remove(...checkedClasses);
          checkbox.classList.add(...notCheckedClasses);
          counter.innerText = `${parseInt(count) - 1 + '/' + total}`
        } else {
          checkbox.classList.remove(...notCheckedClasses);
          checkbox.classList.add(...checkedClasses);
          counter.innerText = `${parseInt(count) + 1 + '/' + total}`
        }
        store.dispatch('projects/projectLogs', {id: route.params.id})
        //reload()
      })
      .catch((err) => {
        console.error('Error updating criteria', err);
      });
}

function submitForm(pipelineId, isEdit = '') {

  const submitBtnLoader = isEdit
      ? document.querySelector(`#form-${pipelineId} button.edit span`)
      : document.querySelector(`#form-${pipelineId} button.add span`);
  submitBtnLoader.classList.remove('d-none')
  submitBtnLoader.classList.add('disable')
  const value = String(document.getElementById(`amount-${pipelineId}`).value).replace(/[^0-9,-]+/g, "");
  const data = {
    name: document.getElementById(`opportunity-${pipelineId}`).value,
    expected_income: parseFloat(value),
    contact_id: document.getElementById(`customer-${pipelineId}`).value,
    opportunity_state_id: pipelineId
  }

  store.dispatch('pipelines/createPipelineSimple', data)
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.pipeline_created"))
        if (isEdit) {
          router.push({name: 'pipelines-view', params: {id: res?.data?.data?.id}})
        }
        loadTaskByStatus(true)
        closeForm(pipelineId);
      })
      .catch((err) => {
      })
      .finally(() => {
        submitBtnLoader.classList.add('d-none')
        submitBtnLoader.classList.remove('disable')
      })
}

function loadData() {
  Promise.all([
    loadTaskByStatus(),
    store.dispatch('company/generalInformation'),
    store.dispatch('contacts/loadContacts'),
    store.dispatch('user/loadUsers')

    
  ]).finally(() => {
    isLoading.value = false
    jkanbanInit()
  })
}

function reload(){
  loadTaskByStatus(true)
}

onBeforeMount(() => {
  const script = document.createElement('script');
  script.src = '/assets/plugins/custom/jkanban/jkanban.bundle.js';
  script.async = false;
  document.head.appendChild(script);

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/assets/plugins/custom/jkanban/jkanban.bundle.css';
  link.type = 'text/css';
  document.head.appendChild(link);
})

onMounted(() => {
  loadData()
})

defineExpose({
  destroyKanban,
  loadTaskByStatus
})
</script>

<style scoped>

  .kanban-item {
    padding: 0 !important;
  }

  .op-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .scroll-container {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100%;
    white-space: nowrap;
    padding: 10px;
    transform: rotateX(180deg);
  }

  .scroll-container > * {
    transform: rotateX(180deg);
  }
</style>


